// React
import * as React from 'react';

// Redux
import { connect } from 'react-redux';

// Managers
//import ColorManager from '../styles/ColorManager';

// Components
//import StatCard from '../components/StatCard';
import Grid from '@material-ui/core/Grid';
import DataTable from '../components/DataTable';
import Typography from '@material-ui/core/Typography';
//import { NetworkManager, MethodRequest_e } from '../managers/NetworkManager';

interface State {
  cardFilter: any;
  cards: any;
}

interface Props {
  location: any;
  navigation: any;
}

/**
 * @description Borrows View
 * @author Lucas Fridez <lucas@fridez.dev>
 * @export
 * @class App
 * @extends {React.Component}
 */
export default connect((state) => state)(class Bookings extends React.Component<Props, State> {

  /**
   * Creates an instance of Borrows.
   * @author Lucas Fridez <lucas@fridez.dev>
   * @param {*} props
   * @memberof App
   */
  constructor(props: any) {
    super(props);
  }

  componentDidMount() {
    document.title = "Rouges-Terres | Réservations";
  }

  /**
   * @description Render the BorrowsView in the Browser
   * @author Lucas Fridez <lucas@fridez.dev>
   * @returns
   * @memberof App
   */
  public render() {
    const columns = [
      { id: 'id', numeric: true, disablePadding: false, label: 'Id' },
      { id: 'lastname', numeric: false, disablePadding: false, label: 'Nom' },
      { id: 'firstname', numeric: false, disablePadding: false, label: 'Prénom' },
      { id: 'confirmed', numeric: false, disablePadding: false, label: 'Confirmé' },
      { id: 'startDate', numeric: false, disablePadding: false, label: 'Date de début' },
      { id: 'endDate', numeric: false, disablePadding: false, label: 'Date de fin' },
      { id: 'price', numeric: false, disablePadding: false, label: 'Prix' }
    ];

    const actions = [
      "close",
      "update",
      "delete",
      "confirm"
    ];

    return (
      <div>
        <Grid container={true} spacing={24}>
          <Grid item={true} xs={12}>
            <Typography variant="headline" gutterBottom={true}>Réservations</Typography>
          </Grid>
        </Grid>

        <DataTable title="Les réservations" actions={actions} columns={columns} rows="bookings/small" apiPath="bookings"
          isPossibleToFilter={false} urlPath="Reservations" />
      </div>
    );
  }
});



// WEBPACK FOOTER //
// ./src/app/views/Bookings.tsx